/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportInspectedOrganizations
 */
export interface ReportInspectedOrganizations {
    /**
     * 
     * @type {object}
     * @memberof ReportInspectedOrganizations
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportInspectedOrganizations
     */
    sum: object;
}

export function ReportInspectedOrganizationsFromJSON(json: any): ReportInspectedOrganizations {
    return ReportInspectedOrganizationsFromJSONTyped(json, false);
}

export function ReportInspectedOrganizationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportInspectedOrganizations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportInspectedOrganizationsToJSON(value?: ReportInspectedOrganizations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


